import React, { useState } from "react";
// @mui material components
import Card from "@mui/material/Card";
import { useNavigate } from "react-router-dom";

// Material Dashboard 2 React components
import MDBox from "components/MDBox";
import MDTypography from "components/MDTypography";

import Swal from "sweetalert2";

import AccountingApi from "../../../../Classes/API/AccountingApi";
import PayFromBalanceReq from "../../../../Classes/Models/Requests/Accounting/PayFromBalanceReq";
import PayFromBalanceButton from "../../../../layouts/AccountingSessions/PayFromBalanceButton";

const AccSessionDetailsCard = ({ Session, setIsLoaded }) => {
  const PayFromBalance = async () => {
    let req = new PayFromBalanceReq();

    req.paymentType = "AccountingSession";
    req.accountingSessionId = Session.id;
    req.userId = Session.getPatient.getUser.id;

    var res = await AccountingApi.PayFromBalance(req);

    if (res.status == "Success") {
      Swal.fire("Success", res.message, "success").then(() => {
        setIsLoaded(false);
      });
    } else {
      Swal.fire("Failed", res.message, "error");
    }
  };

  const GetPayFromBalanceButton = () => {
    if (
      Session.getPatient.getUser.getLastBalanceEntry &&
      Session.getPatient.getUser.getLastBalanceEntry.currentBalance < Session.finalPrice
    ) {
      return (
        <button className="btn btn-danger m-3" disabled={true}>
          Insufficient Funds
        </button>
      );
    } else if (Session.isPaidFor) {
      return (
        <button className="btn btn-success m-3" disabled={true}>
          Session Paid
        </button>
      );
    } else if (!Session.getPatient.getUser.getLastBalanceEntry) {
      return (
        <button className="btn btn-dark m-3" disabled={true}>
          NO BALANCE DETECTED
        </button>
      );
    } else {
      return (
        <button
          className="btn btn-success m-3"
          disabled={Session.isPaidFor}
          onClick={() => PayFromBalance()}
        >
          Pay with balance
        </button>
      );
    }
  };

  return (
    <Card sx={{ height: "100%", boxShadow: !false && "none" }}>
      <MDBox display="flex" justifyContent="space-between" alignItems="center" pt={2} px={2}>
        <MDTypography variant="h6" fontWeight="medium" textTransform="capitalize">
          Accounting Session Info:
        </MDTypography>
      </MDBox>
      <MDBox p={2}>
        <div className="container-fluid">
          <div className="row">
            <div className="col-md-4">
              <MDTypography variant="button" fontWeight="bold" textTransform="capitalize">
                Session Id: &nbsp;
              </MDTypography>
              <MDTypography variant="button" fontWeight="regular" color="text">
                &nbsp;{Session.id}
              </MDTypography>
            </div>
            <div className="col-md-4">
              <MDTypography variant="button" fontWeight="bold" textTransform="capitalize">
                Patient Name: &nbsp;
              </MDTypography>
              <MDTypography variant="button" fontWeight="regular" color="text">
                &nbsp;{Session.getPatient.getUser.name}
              </MDTypography>
            </div>
            <div className="col-md-4">
              <MDTypography variant="button" fontWeight="bold" textTransform="capitalize">
                Patient's Current Balance: &nbsp;
              </MDTypography>
              <MDTypography variant="button" fontWeight="regular" color="text">
                &nbsp;
                {Session.getPatient.getUser.getLastBalanceEntry
                  ? "$" + Session.getPatient.getUser.getLastBalanceEntry.currentBalance
                  : "NO BALANCE AVAILABLE"}
              </MDTypography>
            </div>

            <div className="col-md-4">
              <MDTypography variant="button" fontWeight="bold" textTransform="capitalize">
                Session Name: &nbsp;
              </MDTypography>
              <MDTypography variant="button" fontWeight="regular" color="text">
                &nbsp;{Session.getSession.name}
              </MDTypography>
            </div>

            {Session.getPackage ? (
              <>
                <div className="col-md-4">
                  <MDTypography variant="button" fontWeight="bold" textTransform="capitalize">
                    PackageId: &nbsp;
                  </MDTypography>
                  <MDTypography variant="button" fontWeight="regular" color="text">
                    &nbsp;{Session.packageId}
                  </MDTypography>
                </div>

                <div className="col-md-4">
                  <MDTypography variant="button" fontWeight="bold" textTransform="capitalize">
                    Package Name: &nbsp;
                  </MDTypography>
                  <MDTypography variant="button" fontWeight="regular" color="text">
                    &nbsp;{Session.getPackage.packageName}
                  </MDTypography>
                </div>
                <div className="col-md-4">
                  <MDTypography variant="button" fontWeight="bold" textTransform="capitalize">
                    Package Original Price: &nbsp;
                  </MDTypography>
                  <MDTypography variant="button" fontWeight="regular" color="text">
                    &nbsp;{Session.getPackage.originalPrice} EGP
                  </MDTypography>
                </div>

                <div className="col-md-4">
                  <MDTypography variant="button" fontWeight="bold" textTransform="capitalize">
                    Discount: &nbsp;
                  </MDTypography>
                  <MDTypography variant="button" fontWeight="regular" color="text">
                    &nbsp;{Number(Session.getPackage.discount).toFixed(1)}%
                  </MDTypography>
                </div>

                <div className="col-md-4">
                  <MDTypography variant="button" fontWeight="bold" textTransform="capitalize">
                    Package Final Price: &nbsp;
                  </MDTypography>
                  <MDTypography variant="button" fontWeight="regular" color="text">
                    &nbsp;{Session.getPackage.finalPrice} EGP
                  </MDTypography>
                </div>

                <div className="col-md-4">
                  <MDTypography variant="button" fontWeight="bold" textTransform="capitalize">
                    Original Price: &nbsp;
                  </MDTypography>
                  <MDTypography variant="button" fontWeight="regular" color="text">
                    &nbsp;{Session.originalPrice} EGP
                  </MDTypography>
                </div>

                <div className="col-md-4">
                  <MDTypography variant="button" fontWeight="bold" textTransform="capitalize">
                    Final Price: &nbsp;
                  </MDTypography>
                  <MDTypography variant="button" fontWeight="regular" color="text">
                    &nbsp;{Session.finalPrice} EGP
                  </MDTypography>
                </div>
              </>
            ) : (
              <>
                <div className="col-md-4">
                  <MDTypography variant="button" fontWeight="bold" textTransform="capitalize">
                    Original Price: &nbsp;
                  </MDTypography>
                  <MDTypography variant="button" fontWeight="regular" color="text">
                    &nbsp;{Session.originalPrice} EGP
                  </MDTypography>
                </div>

                <div className="col-md-4">
                  <MDTypography variant="button" fontWeight="bold" textTransform="capitalize">
                    Discount: &nbsp;
                  </MDTypography>
                  <MDTypography variant="button" fontWeight="regular" color="text">
                    &nbsp;{Number(Session.discount).toFixed(1)}%
                  </MDTypography>
                </div>

                <div className="col-md-4">
                  <MDTypography variant="button" fontWeight="bold" textTransform="capitalize">
                    Final Price: &nbsp;
                  </MDTypography>
                  <MDTypography variant="button" fontWeight="regular" color="text">
                    &nbsp;{Session.finalPrice} EGP
                  </MDTypography>
                </div>
              </>
            )}

            <div className="col-md-4">
              <MDTypography variant="button" fontWeight="bold" textTransform="capitalize">
                Is Paid For: &nbsp;
              </MDTypography>
              <MDTypography variant="button" fontWeight="regular" color="text">
                &nbsp;{Session.isPaidFor ? "YES" : "NO"}
              </MDTypography>
            </div>

            <div className="col-md-4">
              <MDTypography variant="button" fontWeight="bold" textTransform="capitalize">
                Is Half Duration: &nbsp;
              </MDTypography>
              <MDTypography variant="button" fontWeight="regular" color="text">
                &nbsp;{Session.isHalfDuration ? "YES" : "NO"}
              </MDTypography>
            </div>

            {/* <div className="col-md-4">
              <MDTypography variant="button" fontWeight="bold" textTransform="capitalize">
                Accounting EntryId: &nbsp;
              </MDTypography>
              <br/>
              <MDTypography variant="button" fontWeight="regular" color="text">
                &nbsp;
                {
                  Session.isPaidFor ? Session.getAccountingEntry ? Session.getAccountingEntry.id : GetPayFromBalanceButton() :
                    <>
                      {GetPayFromBalanceButton()}
                    </>
                }
              </MDTypography>
            </div> */}

            <div className="col-md-4">
              <MDTypography variant="button" fontWeight="bold" textTransform="capitalize">
                Pay: &nbsp;
              </MDTypography>
              <br />
              <PayFromBalanceButton Session={Session} />
            </div>

            <div className="col-md-4">
              <MDTypography variant="button" fontWeight="bold" textTransform="capitalize">
                Appointment Requested: &nbsp;
              </MDTypography>
              <br />
              <MDTypography variant="button" fontWeight="regular" color="text">
                &nbsp;
                {Session.getAppointmentRequest ? (
                  <>
                    <MDTypography variant="button" fontWeight="regular" color="text">
                      &nbsp;ID: {Session.getAppointmentRequest.id}
                    </MDTypography>
                    <MDTypography variant="button" fontWeight="regular" color="text">
                      &nbsp;First Priority Date: {Session.getAppointmentRequest.firstPrioTime}
                    </MDTypography>
                    <MDTypography variant="button" fontWeight="regular" color="text">
                      &nbsp;Second Priority Date: {Session.getAppointmentRequest.secondPrioTime}
                    </MDTypography>
                    <MDTypography variant="button" fontWeight="regular" color="text">
                      &nbsp;Third Priority Date: {Session.getAppointmentRequest.thirdPrioTime}
                    </MDTypography>
                    <MDTypography variant="button" fontWeight="regular" color="text">
                      &nbsp;Notes: {Session.getAppointmentRequest.notes}
                    </MDTypography>
                  </>
                ) : (
                  <MDTypography variant="button" fontWeight="regular" color="text">
                    &nbsp;Appointment Request Not Found, Please Request Appointment Below.
                  </MDTypography>
                )}
              </MDTypography>
            </div>

            <div className="col-md-4">
              <MDTypography variant="button" fontWeight="bold" textTransform="capitalize">
                Appointment Made: &nbsp;
              </MDTypography>
              <br />
              <MDTypography variant="button" fontWeight="regular" color="text">
                &nbsp;
                {Session.getAppointment ? "Yes, Id: " + Session.getAppointment.id : "No"}
              </MDTypography>
            </div>
          </div>
        </div>
      </MDBox>
    </Card>
  );
};

export default AccSessionDetailsCard;
